module.exports = __webpack_public_path__ + "img/ln.ab6c494b.svg";